import BaseUISystem from './BaseUISystem';
import Game from '../../Game';
import GDPRMenuHandler from './Menu/GDPRMenuHandler';
import { ConnectFbSplashScreen } from 'System/UI/Menu/ConnectFbSplashScreen';
import { isNative } from 'Utility/Platform';
import DataConflictsMenuHandler from 'System/UI/Menu/DataConflictsMenuHandler';
import ErrorPopupHandler from 'System/UI/ErrorPopupHandler';
import ProgressionPassedMobileVersion from 'System/UI/Menu/ProgressionPassedMobileVersion';

export default class PreloadUIHandler extends BaseUISystem {
    public init() {
        this.handlers = [];

        const state = Game.store.getState();

        if (!state.playerState.gdprCompliance && isNative()) {
            this.handlers.push(new GDPRMenuHandler(this));
        }

        if (ConnectFbSplashScreen.shouldShow()) {
            this.handlers.push(new ConnectFbSplashScreen(this));
        }

        if (isNative()) {
            this.handlers.push(new DataConflictsMenuHandler(this));
            this.handlers.push(new ErrorPopupHandler(this));
            this.handlers.push(new ProgressionPassedMobileVersion(this));
        }
    }

    async preload(): Promise<void> {
        Game.resource.add('styles', 'resource/data/styles.json');
        await Promise.all([Game.resource.load()]);
    }
}
